import { render, staticRenderFns } from "./ResultRaffleCard.vue?vue&type=template&id=13722965&scoped=true"
import script from "./ResultRaffleCard.vue?vue&type=script&lang=js"
export * from "./ResultRaffleCard.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=13722965&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13722965",
  null
  
)

export default component.exports